const SELECTED_GCS_IDS_KEY = 'selectedGcsIds';

type StorageKey = string;

export class LocalStorageService {
  get<T>(key: StorageKey): T | null {
    const stored = localStorage.getItem(key);
    if (!stored) return null;
    try {
      return JSON.parse(stored) as T;
    } catch {
      return null;
    }
  }

  set<T>(key: StorageKey, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  remove(key: StorageKey): void {
    localStorage.removeItem(key);
  }

  // Selected GCS IDs
  getSelectedGcsIds(): string[] | null {
    return this.get<string[]>(SELECTED_GCS_IDS_KEY);
  }

  setSelectedGcsIds(ids: string[]): void {
    this.set(SELECTED_GCS_IDS_KEY, ids);
  }

  clearSelectedGcsIds(): void {
    this.remove(SELECTED_GCS_IDS_KEY);
  }
}

export const localStorageService = new LocalStorageService();
